<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" style="padding-bottom: 20px !important;">

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs row">
                        <div class="col-xs-12 col-sm-fill hidden-xs">
                            <h3>
                                <i class="las" :class="$router.currentRoute.meta.icon"></i>
                                {{$router.currentRoute.meta.title}}                       
                            </h3>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-12 col-lg-4">
                            <div class="card" style="overflow-y: auto; overflow-x: hidden; max-height: calc(100vh - 190px);">
                                <div class="list-small list">
                                    <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                                        <p class="help">
                                            <i class="las la-question-circle"></i>
                                            Preencha os filtros abaixo e veja as seleções feitas ao lado.
                                        </p>

                                        <div class="row">
                                            <div v-if="form.cod && $root.user.tipo == 'admin'" class="col-xs-12 margin-bottom-20">
                                                <div class="submit-field margin-bottom-0">
                                                    <h4 style="font-weight: 600;">
                                                        Ações:
                                                    </h4>
                                                </div>
                                                <button v-if="form.status == 0" v-on:click="agendar()" type="button" class="button color-green full-width margin-bottom-10">
                                                    <i class="las la-calendar"></i> Agendar visitas
                                                </button>
                                                <button v-if="form.status > 0" v-on:click="$root.go('DetalhesPlanejamentos', JSON.stringify({'c': form.cod}))" type="button" class="button small color-primary full-width margin-bottom-10">
                                                    <i class="las la-eye"></i> Ver detalhes do planejamento
                                                </button>                                                
                                                <button v-if="!(form.status == 0 || form.status == -1 || form.status == 2)" v-on:click="cancelarPendentes()" type="button" class="button small color-orange full-width margin-bottom-10">
                                                    <i class="las la-times"></i> Cancelar visitas pendentes
                                                </button>
                                                <button v-if="!(form.status == 0 || form.status == -1 || form.status == 2)" v-on:click="cancelarTodas()" type="button" class="button small color-red full-width margin-bottom-10">
                                                    <i class="las la-times"></i> Apagar todas as visitas
                                                </button>
                                            </div>

                                            <div class="col-xs-12 col-md-6">
                                                <div class="submit-field margin-bottom-20">
                                                    <h4 style="font-weight: 600;">
                                                        Data inicial:
                                                    </h4>
                                                    <input type="date" required="" class="with-border margin-bottom-0" v-model="form.dataInicio">
                                                </div>
                                            </div>

                                            <div class="col-xs-12 margin-bottom-20">
                                                <h4 style="font-weight: 600;">
                                                    Dias da semana:
                                                </h4>
                                                <div class="row">
                                                    <div class="col-xs-12">
                                                        <div class="checkbox" v-for="(dia, index) in diasSemana" v-bind:class="{'margin-right-20': index + 1 != diasSemana.length}">
                                                            <input style=" border: 0px !important" :value="dia.id" :id="'checkbox-' + dia.id" type="checkbox" v-model="form.diasSemana">
                                                            <label :for="'checkbox-' + dia.id" class="margin-bottom-0">
                                                                <span class="checkbox-icon"></span>
                                                                {{dia.nome}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-xs-12">
                                                <div class="submit-field margin-bottom-20">
                                                    <h4 style="font-weight: 600;">
                                                        Local de origem:
                                                    </h4>
                                                    <input type="text" id="origemInput" class="with-border" min="1" placeholder="Informe o local">
                                                </div>
                                            </div>

                                            <div class="col-xs-12">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5 style="font-weight: 600;">
                                                        Raio:
                                                    </h5>
                                                    <div class="row">
                                                        <div class="col-xs-8">
                                                            <input type="range" min="1" max="150" step="1" required="" class="with-border margin-bottom-0" v-model="form.distanciaRaio">
                                                        </div>
                                                        <div class="col-xs-4">
                                                            <input type="number" min="1" max="1000" step="1" name="visitas-input" required="" class="with-border margin-bottom-0" v-model="form.distanciaRaio">
                                                            <label for="visitas-input">
                                                                Km
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>                                            

                                            <div class="col-xs-12">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5 style="font-weight: 600;">
                                                        Quantas visitas no máximo por dia?:
                                                    </h5>
                                                    <div class="row">
                                                        <div class="col-xs-8">
                                                            <input type="range" min="1" max="100" step="1" required="" class="with-border margin-bottom-0" v-model="form.visitasMaximoDia">
                                                        </div>
                                                        <div class="col-xs-4">
                                                            <input type="number" min="1" max="100" step="1" name="visitas-input" required="" class="with-border margin-bottom-0" v-model="form.visitasMaximoDia">
                                                            <label for="visitas-input">
                                                                Visita(s)
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-xs-12">
                                                <div class="submit-field margin-bottom-10">
                                                    <h5 style="font-weight: 600;">
                                                        Qual a distância máxima de deslocamento por dia?:
                                                    </h5>
                                                    <div class="row">
                                                        <div class="col-xs-8">
                                                            <input type="range" min="1" max="500" step="1" required="" class="with-border margin-bottom-0" v-model="form.distanciaMaximoDia">
                                                        </div>
                                                        <div class="col-xs-4">
                                                            <input type="number" min="1" max="1000" step="1" required="" name="deslocamento-input" class="with-border margin-bottom-0" v-model="form.distanciaMaximoDia">
                                                            <label for="deslocamento-input">
                                                                Km
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <h4 class="margin-bottom-10" style="font-weight: 600;">
                                                    Informações do planejamento:
                                                </h4>
                                            </div>
                                            <div class="col-xs-12">
                                                <div class="submit-field margin-bottom-20">
                                                    <h5>
                                                        Nome do planejamento:
                                                    </h5>
                                                    <input type="text" class="with-border" min="1" placeholder="Informe o nome" v-model="form.nome">
                                                </div>
                                            </div>
                                            <div class="col-xs-12">
                                                <div class="submit-field margin-bottom-20">
                                                    <h5>
                                                        Descrição do planejamento:
                                                    </h5>
                                                    <textarea rows="10" cols="10" class="with-border" placeholder="Escreva uma descrição..." v-model="form.descricao"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-sm-12">
                                                <div class="submit-field margin-bottom-0">
                                                    <h4 style="font-weight: 600;">
                                                        Equipe(s):
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 margin-bottom-20">
                                                <ul>
                                                    <li v-for="(item, index) in equipes.itens" :key="'equipe-' + item.cod" class="padding-left-0 padding-right-0">
                                                        <div class="checkbox">
                                                            <input style=" border: 0px !important" :value="item.cod" :id="'checkbox-equipe-'+ item.cod" v-model="form.equipeCod" type="checkbox">
                                                            <label :for="'checkbox-equipe-'+ item.cod" class="margin-top-10 margin-bottom-10" style="line-height: 130%;">
                                                                <span class="checkbox-icon"></span>
                                                                {{item.nome}}
                                                            </label>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>                                            
                                        </div>
                                        <hr>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <div class="submit-field margin-bottom-0">
                                                    <h4 style="font-weight: 600;">
                                                        Categoria de clientes:
                                                    </h4>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 margin-bottom-20">
                                                <ul>
                                                    <li v-for="(item, index) in categorias.itens" :key="'categoria-' + item.nome" class="padding-left-0 padding-right-0">
                                                        <div class="checkbox">
                                                            <input style=" border: 0px !important" :value="item.nome" :id="'checkbox-categoria-'+ item.nome" v-model="form.categorias" type="checkbox">
                                                            <label :for="'checkbox-categoria-'+ item.nome" class="margin-top-10 margin-bottom-10" style="line-height: 130%;">
                                                                <span class="checkbox-icon"></span>
                                                                {{item.nome}}
                                                            </label>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>                                               
                                            <div class="col-xs-12">
                                                <h4 class="margin-bottom-10" style="font-weight: 600;">
                                                    Clientes selecionados ({{qntdClientesSelecionados}}):
                                                </h4>
                                                <div class="submit-field margin-bottom-10">
                                                    <input type="text" v-on:keyup="update" placeholder="Pesquise um cliente.." class="with-border margin-bottom-0" v-model="pesquisaClientes">
                                                </div>{{clientes.nome}}
                                                <a v-if="!clientes.mostrar" v-on:click="clientes.mostrar = true; update();" class="click">
                                                    <small>
                                                        <i class="las la-chevron-down"></i>
                                                        Editar clientes
                                                    </small>
                                                </a>
                                                <a v-if="clientes.mostrar" v-on:click="clientes.mostrar = false; update();" class="click">
                                                    <small>
                                                        <i class="las la-chevron-up"></i>
                                                        Editar clientes
                                                    </small>
                                                </a>
                                            </div>
                                            <div class="col-xs-12" v-if="clientes.mostrar">
                                                <ul>
                                                    <li v-for="(item, index) in clientes.pesquisa" :key="'cliente-' + item.cod" class="padding-left-0 padding-right-0">
                                                        <div class="checkbox">
                                                            <input style=" border: 0px !important" :value="item.cod" :id="'checkbox-cliente-'+ item.cod" v-model="form.clientes" type="checkbox">
                                                            <label :for="'checkbox-cliente-'+ item.cod" class="margin-top-10 margin-bottom-10" style="line-height: 130%;">
                                                                <span class="checkbox-icon"></span>
                                                                {{item.empresa ? item.empresa : item.nome}}
                                                                <small style="display: block; line-height: 120%;" class="margin-top-5">
                                                                    {{item.endereco}}, {{item.numero != '' ? item.numero : 's/n'}}. {{item.cep}}. {{item.bairro}}. {{item.cidade}} - {{item.estado}}
                                                                </small>
                                                            </label>
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="row margin-top-30">

                                            <div class="col-xl-12">
                                                <button type="submit" class="button color-green full-width margin-bottom-20" v-bind:class="{'disabled': loading.submit || form.status > 0 }">
                                                    <i class="las la-save"></i>
                                                    Salvar planejamento
                                                </button>                                            
                                            </div>
                                        </div>

                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-lg-8" style=" height: calc(100vh - 190px)">
                            <div class="mapa" style="width: 100%; height: 100%;"></div>
                        </div>
                    </div>                

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'
import AvatarCropper from "vue-avatar-cropper"

export default {
    name: 'GerenciarPlanejamentos',
    components: {
        'AvatarCropper': AvatarCropper,
        'Top':      Top,
        'Sidebar':  Sidebar,
        'Toolbar':  Toolbar
    },          
    data () {
        var self                    = this;
        return {
            "salvo":                false,
            "qntdClientesSelecionados": 0,
            "pesquisaClientes":     "",
            "loading": {
                "submit":           false
            },            
            "categorias": {
                "itens":            []
            },
            "equipes": {
                "itens":            []
            },
            "markers":              {},
            "clientes": {
                "itens":            [],
                "pesquisa":         [],
                "nome":             "",
                "mostrar":          false
            },            
            "form": {
                "_cod":                 "",
                "_token":               "",
                "equipeCod":            [],
                "diasSemana":           [1,2,3,4,5],
                "origemNome":           null,
                "origemLatitude":       null,
                "origemLongitude":      null,
                "visitasMaximoDia":      10,
                "distanciaRaio":        10,
                "distanciaMaximoDia":   5,
                "categorias":           [],
                "clientes":             []
            },
            "diasSemana": [
                {
                    "id":           1,
                    "nome":         "Segunda-feira",
                },
                {
                    "id":           2,
                    "nome":         "Terça-feira",
                },
                {
                    "id":           3,
                    "nome":         "Quarta-feira",
                },
                {
                    "id":           4,
                    "nome":         "Quinta-feira",
                },
                {
                    "id":           5,
                    "nome":         "Sexta-feira",
                },
                {
                    "id":           6,
                    "nome":         "Sábado",
                },
                {
                    "id":           0,
                    "nome":         "Domingo"
                }
            ],     
        }
    },
    computed: {

    },
    watch: {
        "form.categorias": {
            immediate: true,
            deep: true,           
            handler: function(val) {
                console.log("form.categorias >", val)
                var self = this;
                self.atualizarMapaPontos();
                self.atualizarMapaRaio();

            },
        },
        "form.clientes": {
            immediate: true,
            deep: true,           
            handler: function(val) {
                console.log("form.clientes >", val)
                var self = this;
                if (val) {
                    self.qntdClientesSelecionados = val.length;
                    self.$forceUpdate();
                }
            },
        },        
        "form.distanciaRaio": function(val) {
            var self = this;
            console.log("watch > distanciaRaio", val);
            self.atualizarMapaRaio();
        },
        "pesquisaClientes": {
            immediate: true,
            deep: true,           
            handler: function(val) {
                console.log("clientes.nome >", val)
                var self = this;
                var itens = [];

                if (self.pesquisaClientes) {
                    if (!self.clientes.mostrar) {
                        self.clientes.mostrar = true;
                    }
                    JSON.parse(JSON.stringify(self.clientes.itens)).forEach(function(item, index) {
                        var str1 = clean(self.pesquisaClientes);
                        if (clean(item.nome).indexOf(str1) != -1 || clean(item.empresa).indexOf(str1) != -1) {
                            itens.push(item);
                        }
                    });
                } else {
                    itens = JSON.parse(JSON.stringify(self.clientes.itens)); 
                }

                self.clientes.pesquisa = JSON.parse(JSON.stringify(itens));
                self.$forceUpdate();
            },
        }
    },    
    methods: {
        agendar: function(e) {
            var self            = this;
            console.log("agendar()") 

            confirm("Você tem certeza que deseja agendar todas as visitas desse planejamento?", function() {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          self.form.cod,
                    "acao":         "agendar"
                };
                loading.show();
                
                axios.put("api/planejamentos.php", form)
                .then(response => {
                    loading.hide();
                    console.log("agendar() response", response)
                    alert(response.data.message);
                    self.$root.go('DetalhesPlanejamentos', JSON.stringify({'c': self.form.cod}));
                })
                .catch(error => {
                    console.log("agendar() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });

        },
        cancelarPendentes: function(e) {
            var self            = this;
            console.log("cancelarPendentes()") 

            confirm("Você tem certeza que deseja cancelar todas as visitas pendentes desse planejamento? Atenção, essa ação não poderá ser desfeita.", function() {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          self.form.cod,
                    "acao":         "cancelar-visitas"
                };
                loading.show();
                
                axios.put("api/planejamentos.php", form)
                .then(response => {
                    loading.hide();
                    console.log("cancelarPendentes() response", response)
                    alert(response.data.message);
                    self.get();
                })
                .catch(error => {
                    console.log("cancelarPendentes() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });

        },
        cancelarTodas: function(e) {
            var self            = this;
            console.log("cancelarTodas()") 

            confirm("Você tem certeza que deseja apagar todas as visitas desse planejamento? Atenção, essa ação não poderá ser desfeita.", function() {

                var form = {
                    "_cod":         self.$root.user.cod, 
                    "_token":       self.$root.user.token,
                    "cod":          self.form.cod,
                    "acao":         "apagar-visitas"
                };
                loading.show();
                
                axios.put("api/planejamentos.php", form)
                .then(response => {
                    loading.hide();
                    console.log("cancelarTodas() response", response)
                    alert(response.data.message);
                    self.get();
                })
                .catch(error => {
                    console.log("cancelarTodas() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });            
        },                
        submit: function(e) {
            var self            = this;
            
            if (self.form.status > 0) return false;

            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            var a = "post";
            if (self.form.cod) {
                a = "put";
            }

            console.log("acao", a);

            axios[a]("api/planejamentos.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                // self.$root.back();

                self.salvo          = true;
                if (!self.form.cod) {
                    self.form.cod = response.data.result.cod;
                    self.$forceUpdate();
                    self.agendar();
                }

                self.get();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        getEquipes: function() {
            var self        = this;
            console.log("getEquipes()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "page":         1
                    }
                };

                axios.get("api/equipes.php", form)
                .then(response => {
                    
                    console.log("getEquipes() response", response);
                    self.equipes       = response.data.result;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEquipes() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        }, 
        getCategorias: function() {
            var self        = this;
            console.log("getCategorias()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "tipo":         "categorias"
                    }
                };

                axios.get("api/clientes.php", form)
                .then(response => {
                    
                    console.log("getCategorias() response", response);
                    self.categorias         = response.data.result;
                    self.$forceUpdate();

                    loading.hide();

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getCategorias() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },
        getClientes: function() {
            var self        = this;
            console.log("getClientes()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "all":          true,
                        "page":         1
                    }
                };

                axios.get("api/clientes.php", form)
                .then(response => {
                    
                    console.log("getClientes() response", response);
                    self.clientes       = response.data.result;

                    self.clientes.pesquisa  = JSON.parse(JSON.stringify(self.clientes.itens));
                    self.pesquisaClientes      = "";
                    self.clientes.mostrar   = false;
                    self.$forceUpdate();

                    setTimeout(function() {
                        self.atualizarMapaPontos();
                        self.atualizarMapaRaio();
                        loading.hide();
                    }, 1000);
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getClientes() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });   
            });   
        },                   
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/planejamentos.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.form           = response.data.result;
                    self.loaded         = true;
                    loading.hide();
                    self.$forceUpdate();
                    $("#origemInput").val(self.form.origemNome);

                    self.initMapa();

                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },
        del: function(cod) {
            console.log("del()", cod);
            var self                = this;
            confirm("Você tem certeza que deseja apagar?", function() {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          cod
                    }
                };
                loading.show();
                
                axios.delete("api/planejamentos.php", form)
                .then(response => {
                    console.log("del() response", response)
                    self.salvo          = true;
                    self.$root.back();
                })
                .catch(error => {
                    console.log("del() error", error)
                    loading.hide();
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                });
            });
        },
        initMapa: function() {
            console.log("initMapa()");
            var self                = this;
                    
            self.mapaCentro         = { lat: parseFloat(self.form.origemLatitude), lng: parseFloat(self.form.origemLongitude) };

            setTimeout(function() {

                self.mapa       = new google.maps.Map($(".mapa")[0], {
                    center:     self.mapaCentro,
                    zoom:       12,
                    disableDefaultUI: true,
                });

                // self.atualizarMapaRaio();

                
                // Create a bounding box with sides ~10km away from the center point
                var input       = document.getElementById("origemInput");
                var options     = {
                  // bounds: defaultBounds,
                    componentRestrictions:  { country: "br" },
                    fields:                 ["address_components", "geometry", "icon", "name"],
                    strictBounds:           false,
                    types:                  ["establishment"],
                };
                self.autocomplete           = new google.maps.places.Autocomplete(input, options);
                self.autocomplete.addListener('place_changed', function(result) {
                    console.log("place_changed>", result);
                    var place = self.autocomplete.getPlace();

                    self.form.origemNome        = place.name;
                    self.form.origemLatitude    = place.geometry.location.lat();
                    self.form.origemLongitude   = place.geometry.location.lng();
                    console.log("place", place);
                    console.log("map", self.mapa);

                    var latlng = new google.maps.LatLng(self.form.origemLatitude, self.form.origemLongitude);
                    self.mapa.setCenter(latlng);
                    self.mapaCentro = latlng;
                    self.$forceUpdate();
                    self.atualizarMapaPontos();
                    self.atualizarMapaRaio();
                });

                console.log("inicializou origemInput", self.autocomplete)
            }, 500);
        },
        atualizarMapaRaio: function() {
            var self = this;
            console.log("atualizarMapaRaio()");
            if (self.mapaRaio)  self.mapaRaio.setMap(null);
            self.mapaRaio       = new google.maps.Circle({
                strokeColor:    "#FF0000",
                strokeOpacity:  0.8,
                strokeWeight:   2,
                fillColor:      "#FF0000",
                fillOpacity:    0.35,
                map:            self.mapa,
                center:         self.mapaCentro,
                radius:         self.form.distanciaRaio * 1000,
                // radius: Math.sqrt(citymap[city].population) * 100,
            });

            self.form.clientes = [];
            self.clientes.itens.forEach(function(item) {
                if (parseFloat(item.distancia) <= parseFloat(self.form.distanciaRaio) && item.mostrar == true) {
                    console.log("item mostrar?", item, item.mostrar)
                    self.form.clientes.push(item.cod);
                } else {
                    console.log("item nao mostrar", item.distancia)
                }
            });
            self.$forceUpdate();
        },
        atualizarMapaPontos: function() {
            var self = this;
            console.log("atualizarMapaPontos()");

            Object.keys(self.markers).forEach(function(item) {
                // console.log("MARKER>", self.markers[item])
                self.markers[item].setMap(null);
            });

            self.qntdClientesSelecionados = 0;

            self.clientes.itens.forEach(function(item, index) {

                // calcular distancia
                self.clientes.itens[index]["distancia"] = parseFloat(getDistanceKm(self.form.origemLatitude, self.form.origemLongitude, item.latitude, item.longitude).toFixed(2));
                // console.log("setou distancia", self.clientes.itens[index]["distancia"]);

                self.clientes.itens[index]["mostrar"] = false;

                if (self.form.categorias.length > 0) {
                    if (self.form.categorias.indexOf(item.categoria) != -1) {
                        self.clientes.itens[index]["mostrar"]   = true;
                        self.qntdClientesSelecionados++;
                        console.log("Mostrar = true 1")
                    }
                } else {
                    console.log("Mostrar = true 2")
                    self.qntdClientesSelecionados++;
                    self.clientes.itens[index]["mostrar"]       = true;
                }

                if (self.clientes.itens[index]["mostrar"] == true) {
                    var infoWindow  = new google.maps.InfoWindow();
                    var latLng      = { lat: parseFloat(item.latitude), lng: parseFloat(item.longitude) };
                    self.markers[item.cod] = new google.maps.Marker({
                        position:   latLng,
                        map:        self.mapa,
                        title:      "<b>" + (item.nome ? item.nome : item.empresa) + "</b><br>" + item.endereco + ", " + (item.numero != '' ? item.numero : 's/n') + ". " + item.cep + ". " + item.bairro + ". " + item.cidade + " - " +  item.estado,
                    });          

                    self.markers[item.cod].addListener("click", () => {
                        infoWindow.close();
                        infoWindow.setContent(self.markers[item.cod].getTitle());
                        infoWindow.open(self.markers[item.cod].getMap(), self.markers[item.cod]);
                    });                      
                }

            });

        },
        update: function() {
            this.$forceUpdate();
        },
        init: function() {
            var self = this;
            console.log("init()");

            if (self.$route.name == "EditarPlanejamentos") {
                if (!self.$route.query.c) {
                    self.$root.back();
                    return false;
                }
                loading.show();
                self.form.cod = self.$route.query.c;
                Promise.resolve()
                .then(self.get)
                .then(self.getEquipes)
                .then(self.getClientes)
                .then(self.getCategorias)
                .finally(function() {
                    
                })
            } else {

                self.form.origemNome        = self.$root.config.configuracoes.origemNome;
                $("#origemInput").val(self.form.origemNome);
                self.form.origemLatitude    = self.$root.config.configuracoes.origemLatitude;
                self.form.origemLongitude   = self.$root.config.configuracoes.origemLongitude;

                // loading.hide();
                Promise.resolve()
                .then(self.getEquipes)
                .then(self.getClientes)
                .then(self.getCategorias)
                .then(self.initMapa)
                .finally(function() {
                    
                })            
            }                        
        }
    },    
    created: function() {
        var self = this;
        console.log("created", self);

    },
    activated: function() {
        var self = this;

        self.init();
    },
    beforeRouteLeave (to, from, next) {
        var self = this;
        if (!self.salvo) {
            const answer = window.confirmWeb('Você tem certeza que deseja sair da página atual? Modificações não salvas podem ser perdidas.')
            if (!answer) return false;
        }
        next();
    }    
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .card .dashboard-status-button {
        margin-top: 8px;
    }

    .uploadButton-button {
        display: none !important;
    }        
    .button.gray.block-mobile {
        font-weight: 400;
        border: 1px solid #ddd !important;
    }

    .imagem-preview {
        width: 100%;
        height: 35vh;
        border-radius: 10px;
        margin-bottom: 25px !important;
        background-size: contain;
        background-color: #ddd;
        background-position: center;
        background-repeat: no-repeat;
    }    

    .uploadButton .uploadButton-input {
        opacity: 0 !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/GerenciarPlanejamentos.vue